// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeFirestore, memoryLocalCache } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyAHq5cUwZWpxRyCGdsnYY52aGmmgGQ4XMc", // public identifier
  authDomain: "cardgrader-f0ef9.firebaseapp.com",
  projectId: "cardgrader-f0ef9",
  // Keep the standard Firebase value here
  storageBucket: "cardgrader-f0ef9.appspot.com",
  messagingSenderId: "262289702852",
  appId: "1:262289702852:web:b275cf41bac92331a7ee91",
};

// 1) Initialize app
const app = initializeApp(firebaseConfig);

// 2) App Check (site key is public by design)
export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LcilqYrAAAAAFAcHVtFMqKN8CwZG0nJB-CtvCUe"),
  isTokenAutoRefreshEnabled: true,
});

// 3) Services
export const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
  experimentalAutoDetectLongPolling: true, // helpful for some networks
});

export const auth = getAuth(app);

// IMPORTANT: Point Storage explicitly at your actual bucket (firebasestorage.app)
export const storage = getStorage(
  app,
  "gs://cardgrader-f0ef9.firebasestorage.app"
);

// Cloud Functions (region us-central1)
export const functions = getFunctions(app, "us-central1");

// (Optional) During local dev, you can connect to emulators:
// if (location.hostname === "localhost") {
//   const { connectAuthEmulator } = await import("firebase/auth");
//   const { connectFirestoreEmulator } = await import("firebase/firestore");
//   const { connectStorageEmulator } = await import("firebase/storage");
//   const { connectFunctionsEmulator } = await import("firebase/functions");
//   connectAuthEmulator(auth, "http://localhost:9099");
//   connectFirestoreEmulator(db, "localhost", 8080");
//   connectStorageEmulator(storage, "localhost", 9199);
//   connectFunctionsEmulator(functions, "localhost", 5001);
// }
